<template>
  <div class="builder-holder">
    <div class="row">
      <div class="col-12">
        <q-table
          class="sticky-column"
          dense
          :data="tableData"
          :columns="getColumns"
          :separator="separator"
          :visible-columns="visibleColumns"
          row-key="name"
          :color="appSettings.defaulted.table_color"
          :pagination="pagination"
          :rows-per-page-options="[0]"
        >
          <!-- Custom renderer for "action" column with button for custom action -->
          <q-tr slot="body" slot-scope="props" :props="props">
            <q-td v-for="col in props.cols" :key="col.name" :props="props">
              <span v-if="col.name === 'modules'">
                <q-icon
                  v-if="props.row.child"
                  size="sm"
                  color="primary-darkened"
                  name="subdirectory_arrow_right"
                  class="q-ml-lg"
                />
                {{ col.value }}
              </span>
              <span v-else>
                <span v-for="(permission, index) in col.value" class="no-wrap">
                  <q-checkbox
                    :key="`permission-${index}`"
                    v-model="permissions[col.role_id]"
                    :label="permission.operation.name"
                    color="primary"
                    :val="permission.id"
                    size="xs"
                    @input="val => updatePermissions(val, col.role_id)"
                  />
                </span>
              </span>
            </q-td>
          </q-tr>
          <template slot="top-right" slot-scope="props">
            <qtable-custom-slot-top-right
              :columns="getColumns"
              :separator.sync="separator"
              :visible-columns.sync="visibleColumns"
              :slot-props="props"
            >
            </qtable-custom-slot-top-right>
          </template>
        </q-table>
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'lodash'
import { PaginationMixin } from 'src/application/global/mixins'
import { mapGetters } from 'vuex'

export default {
  name: 'Builder',
  mixins: [PaginationMixin],
  props: {
    roles: {
      type: Array,
      required: true,
    },
    modules: {
      type: Array,
      required: true,
    },
    updateCallBack: {
      type: Function,
      required: true,
    },
  },
  data: () => ({
    localRoles: [],
    tableData: [],
    pagination: {
      rowsPerPage: 0,
    },
    permissions: {},
  }),
  watch: {
    modules: {
      handler(to) {
        this.prepareTableData(to)
      },
      deep: true,
    },
    getColumns: {
      handler(to) {
        this.setVisibleColumns(to)
        this.setSeparator('cell')
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters(['getBuilderRoleByID']),
    getColumns() {
      let subscriptionRoles = this.roles.map(x => {
        let ids = _.cloneDeep(this.$helpers.getValue(this.getBuilderRoleByID(x.id), 'permissions.ids', []))
        this.permissions = {
          ...{
            [x.id]: [...ids],
          },
          ...this.permissions,
        }
        return {
          name: x.label,
          label: x.label,
          field: 'permissions',
          align: 'left',
          role_id: x.id,
        }
      })

      subscriptionRoles = [
        ...[
          {
            name: 'modules',
            label: this.$ts('words.modules'),
            field: 'label',
            align: 'left',
          },
        ],
        ...subscriptionRoles,
      ]

      return subscriptionRoles
    },
  },
  methods: {
    getSubscriptionPermissions(id) {
      return this.getBuilderRoleByID(id)
    },
    updatePermissions(values, id) {
      let role = _.cloneDeep(this.getBuilderRoleByID(id))
      role.permissions.ids = [...values]
      this.updateCallBack(role)
    },
    prepareTableData(modules, isChild = false) {
      modules.forEach(x => {
        this.tableData.push({
          label: x.label,
          child: isChild,
          permissions: x.permissions,
        })
        if (x.childs && x.childs.length > 0) {
          this.prepareTableData(x.childs, true)
        }
      })
    },
  },
}
</script>
<style lang="sass">
.sticky-column
  thead tr:first-child th:first-child
    /* bg color is important for th; just specify one */
    background-color: $amber-1

  td:first-child
    background-color: $amber-1

  tr th
    position: sticky
    /* higher than z-index for td below */
    z-index: 2
    /* bg color is important; just specify one */
    background: #fff

  /* this will be the loading indicator */
  thead tr:last-child th
    /* height of all previous header rows */
    top: 48px
    /* highest z-index */
    z-index: 3
  thead tr:first-child th
    top: 0
    z-index: 1
  tr:first-child th:first-child
    /* highest z-index */
    z-index: 3

  td:first-child
    z-index: 1

  td:first-child, th:first-child
    position: sticky
    left: 0
</style>
